import { Route, Routes } from 'react-router-dom';

import { BrowsePage } from '@/pages/BrowsePage';
import { CompetitionDetailPage } from '@/pages/CompetitionDetailPage';
import { SubmitWizardPage } from '@/pages/SubmitWizardPage';
import { ThanksPage } from '@/pages/ThanksPage';
import { MySubmissionsPage } from '@/pages/MySubmissionsPage';
import { AnnouncementPage } from '@/pages/AnnouncementPage';
import { LoginPage } from '@/pages/LoginPage';

export function App() {
	return (
		<div className="ll-bg-app min-h-screen">
			<Routes>
				<Route path="/" element={<BrowsePage />} />
				<Route path="/login" element={<LoginPage />} />
				<Route path="/competitions/:slug" element={<CompetitionDetailPage />} />
				<Route path="/competitions/:slug/submit" element={<SubmitWizardPage />} />
				<Route path="/competitions/:slug/thanks" element={<ThanksPage />} />
				<Route path="/competitions/:slug/announcement" element={<AnnouncementPage />} />
				<Route path="/my-submissions" element={<MySubmissionsPage />} />
				<Route path="*" element={<BrowsePage />} />
			</Routes>
		</div>
	);
}
